import _ from 'underscore';

import { DATA_SOURCE_KEY_MAPPING } from '../site-config-structure';
import { componentsConfig } from '../component-config';
import { getDataSourceByKey, getComponentByTypes } from '../site-config-reader';

/**
 * Get all image ids in component config
 * We have logo from header, cover image, gallery, updates and reviews
 * id collision for Smart Page image id
 * @param {object} siteConfig smart page config
 * @returns {object} image id list map for each type
 */
export const getAllImageIdsWithType = (siteConfig) => {
  const logoImageId = getDataSourceByKey(siteConfig, DATA_SOURCE_KEY_MAPPING.LogoImageId);
  const [
    photoConfig,
    coverImageConfig,
    updateConfig,
    reviewConfig,
  ] = getComponentByTypes(siteConfig, [
    componentsConfig.gallery.type,
    componentsConfig.coverImage.type,
    componentsConfig.update.type,
    componentsConfig.review.type,
  ]);

  const { photos } = photoConfig || {};
  const { imageId: coverImageId } = coverImageConfig || {};
  const { updates } = updateConfig || {};
  const { reviews } = reviewConfig || {};

  // Don't do distinct imageId, we need each usage of an image
  return {
    logo: logoImageId ? [logoImageId] : [],
    gallery: !_.isEmpty(photos) ? _.compact(_.map(photos, photo => photo.imageId)) : [],
    update: !_.isEmpty(updates) ? _.compact(_.map(updates, update => update.imageId)) : [],
    reviewer: !_.isEmpty(reviews) ? _.compact(_.map(
      reviews,
      review => review.reviewer && review.reviewer.imageId
    )) : [],
    coverImage: coverImageId ? [coverImageId] : [],
  };
};

export const filterImageIdsToRemove = (siteConfig, imageIdsToRemove) => {
  if (_.isEmpty(imageIdsToRemove) || !_.isArray(imageIdsToRemove)) {
    return [];
  }

  const allImageIds = _.flatten(Object.values(getAllImageIdsWithType(siteConfig)));

  const finalImageIdsToRemove = [];

  imageIdsToRemove.forEach((imageId) => {
    const count = allImageIds.filter(id => imageId === id).length;

    // Save to remove the image if it was used only once
    if (count <= 1) {
      finalImageIdsToRemove.push(imageId);
    }
  });

  return finalImageIdsToRemove;
};

export const getImageMetaById = (siteConfig, imageId) => {
  if (!imageId) return {};

  const image = _.find(siteConfig.images, ({
    IdString,
  }) => (imageId === IdString));

  return image || {};
};

export const getImageUrlById = (siteConfig, imageId) => {
  const image = getImageMetaById(siteConfig, imageId);

  return image && image.ImageUrl;
};
